export default __webpack_public_path__ + "static/media/hero-big-cat.71124913.svg";